import { AccessDeniedError, AuthorizationError } from '#object-store/types';
const S3_ACCESS_DENIED_ERROR_CODE = 'AccessDenied';
/**
 * Classifies a 403 from S3 by its `<Code>` value. `AccessDenied` means the credentials were accepted
 * but lack the requested permission; every other refusal - including a response that carried no code
 * at all - stays a plain `AuthorizationError`, since we know the request was refused but not why.
 */
export const createS3AuthorizationError = (message, errorCode) => errorCode === S3_ACCESS_DENIED_ERROR_CODE
    ? new AccessDeniedError(message, errorCode)
    : new AuthorizationError(message, errorCode);
